import * as React from 'react';
import LayoutOne from './LayoutOne';
import LayoutTwo from './LayoutTwo';
import LayoutThree from './LayoutThree';
import LayoutFour from './LayoutFour';
import LayoutFive from './LayoutFive';
import LayoutSix from './LayoutSix';
import LayoutSeven from './LayoutSeven';
import LayoutEight from './LayoutEight';
import LayoutNine from './LayoutNine';
import LayoutTen from './LayoutTen';
import LayoutEleven from './LayoutEleven';

interface DynamicProps {
  data: {
    sys: {
      id: string;
      type: string;
    };
    bentoBoxCollection: {
      items: {
        __typename: string;
        sys: {
          id: string;
          type: string;
        };
      }[];
    };
    layout: {
      id: number;
      title: string;
      sys: {
        id: string;
      };
    };
  };
}

interface DefaultLayoutProps {
  sys: {
    id: string;
    type: string;
  };
  bentoBoxCollection: {
    items: {
      __typename: string;
      sys: {
        id: string;
        type: string;
      };
    }[];
  };
  layout: {
    id: number;
    title: string;
  };
}

const DefaultLayout = ({ data }: { data: DefaultLayoutProps }) => (
  <div>
    <h2>Default Dynamic Layout</h2>
    <p>
      <strong>Layout Entry ID:</strong> {data?.sys?.id}
    </p>
    <p>
      <strong>Bento Boxes:</strong> {data?.bentoBoxCollection?.items?.length || 0}
    </p>
    <p>
      <strong>Layout ID:</strong> {data?.layout?.id}
    </p>
    <p>
      <strong>Layout Title:</strong> {data?.layout?.title}
    </p>
  </div>
);

const Dynamic = (data: DynamicProps) => {
  const layoutId = data.data?.layout?.id;

  switch (layoutId) {
    case 1:
      return <LayoutOne data={data.data.bentoBoxCollection} />;
    case 2:
      return <LayoutTwo data={data.data.bentoBoxCollection} />;
    case 3:
      return <LayoutThree data={data.data.bentoBoxCollection} />;
    case 4:
      return <LayoutFour data={data.data.bentoBoxCollection} />;
    case 5:
      return <LayoutFive data={data.data.bentoBoxCollection} />;
    case 6:
      return <LayoutSix data={data.data.bentoBoxCollection} />;
    case 7:
      return <LayoutSeven data={data.data.bentoBoxCollection} />;
    case 8:
      return <LayoutEight data={data.data.bentoBoxCollection} />;
    case 9:
      return <LayoutNine data={data.data.bentoBoxCollection} />;
    case 10:
      return <LayoutTen data={data.data.bentoBoxCollection} />;
    case 11:
      return <LayoutEleven key={data.data.bentoBoxCollection.items[0]?.sys?.id} data={data.data.bentoBoxCollection} />;
    default:
      return <DefaultLayout data={data.data} />;
  }
};

export default Dynamic;
